import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

@Injectable()
export class VeiculoVendidoGacService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  private valorRecebido = new BehaviorSubject<any>(null);
  valorModal$ = this.valorRecebido.asObservable();

  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/veiculo/vendido`;
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealers?: any,
    grupo_economico?: any,
    chassi?: any,
    situacao?: any,
    vendaDireta?: any,
    status?: any,
  ): Observable<any> {
    let params = new HttpParams();

    // Use alternate date parameter names depending on the status
    // status == 1 => cancellation dates
    // status == 3 => return/devolution dates
    // otherwise use the regular data_inicial / data_final
    if (status == 1) {
      if (data_inicial) params = params.set('data_inicial_cancelamento', data_inicial.toString());
      if (data_final) params = params.set('data_final_cancelamento', data_final.toString());
    } else if (status == 3) {
      if (data_inicial) params = params.set('data_inicial_devolucao', data_inicial.toString());
      if (data_final) params = params.set('data_final_devolucao', data_final.toString());
    } else {
      if (data_inicial) params = params.set('data_inicial', data_inicial.toString());
      if (data_final) params = params.set('data_final', data_final.toString());
    }
    if (dealers) params = params.set('dealers', dealers.toString());
    if (grupo_economico) params = params.set('grupo_economico', grupo_economico.toString());
    if (chassi) params = params.set('chassi', chassi.toString());
    if (situacao) params = params.set('situacao', situacao.toString());
    if (vendaDireta) params = params.set('venda_direta', vendaDireta.toString());
    if (status) params = params.set('status', status.toString());

    return this.httpClient.get<any>(`${this.baseUrlService + '/veiculo/vendidoGAC'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: params
    });
  }

  atualizarModal(event: any) {
    this.valorRecebido.next(event)
  }

  receberValorModal() {
    return this.valorRecebido.getValue()
  }
}
